module.exports = __webpack_public_path__ + "img/8709d3b.jpg";